import React from 'react';



const Button = ({ onClick, type = "submit", title, disabled = false, loading = false, isFullWidth = false, size = "md", Icon, color = "teal" }) => {
    return <div className={isFullWidth ? `test__InputContainer ${size}` : `btnContainer ${size}`}>
        <button type={type} onClick={onClick} disabled={disabled || loading} className={`btn ${color}`}>
            {title} {Icon && <Icon />} {loading && <span className='loading'></span>}
        </button>
    </div>
}

export default Button
